import React from 'react';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';
import CheckboxInput from '../inputs/CheckboxInput';
import Pagination from '../Pagination';
import SelectInput from '../inputs/SelectInput';
import TableRow from './TableRow';
import TextInput from '../inputs/TextInput';
import AlertMessage from '../message/AlertMessage';

class Table extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.toggleSelectRow = this.toggleSelectRow.bind(this);
    this.toggleSelectAll = this.toggleSelectAll.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelectPageSize = this.onSelectPageSize.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);
    this.getSelectedRows = this.getSelectedRows.bind(this);
    this.selectRows = this.selectRows.bind(this);
    this.getEmptySelection = this.getEmptySelection.bind(this);

    this.state = {
      selection: this.getEmptySelection(),
      query: '',
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.rows) {
      this.selectRows(newProps.rows);
    }
  }

  selectRows(rows) {
    this.getEmptySelection();
    let selection = this.state.selection;
    (rows || []).forEach((row, i) => {
      if ('defaultCheck' in row) {
        selection[i] = row.defaultCheck;
      }
    });

    this.setState({
      selection,
    });
  }
  getEmptySelection() {
    let selection = [];
    let size = Math.max(this.props.pageSize || 0, this.props.rows.length);
    for (let i = 0; i < size; i++) {
      selection[i] = false;
    }
    return selection;
  }

  toggleSelectRow(event, rowIndex, selected) {
    let selection = this.state.selection;
    selection[rowIndex] = selected;
    this.setState({ selection });
  }

  toggleSelectAll(event) {
    let selected = event.target.checked;
    let selection = this.getEmptySelection();

    selection.forEach((row, index) => {
      if (
        this.props.cantEdit &&
        this.props.cantEdit.length === 1 &&
        this.props.rows &&
        this.props.rows[index] &&
        this.props.rows[index].id &&
        this.props.cantEdit[0] === this.props.rows[index].id
      ) {
      } else {
        selection[index] = selected;
      }
    });
    this.setState({ selection });
  }

  onSearchInputChange(event) {
    this.setState({
      query: event.target.value,
    });
  }

  onSearch(event) {
    event.preventDefault();
    if (this.props.searchCallback) {
      this.props.searchCallback(this.state.query);
    }
  }

  onSelectPageSize(event) {
    this.props.onSelectPageSize(parseInt(event.target.value, 10), this.state.query);
  }

  onSelectPage(page) {
    this.setState({
      selection: this.getEmptySelection(),
    });
    this.props.onSelectPage(page, this.state.query);
  }

  getSelectedRows() {
    return this.props.rows.map((row, index) => {
      return this.state.selection[index] === true && row;
    });
  }

  getCheckboxValues() {
    return this.state.selection;
  }

  render() {
    let columnHeaders = [];

    if (this.props.bulkActions) {
      columnHeaders.push(
        <CheckboxInput key="0" name="selectAll" label="" onChange={this.toggleSelectAll} extraClass="select-all" />
      );
    }
    this.props.columns.forEach((column) => {
      columnHeaders.push(column.title);
    });

    let pageSizes = [];
    const maxSize = 100;
    let rowCount = this.props.rowCount || this.props.pageSize;
    if (rowCount) {
      for (let size = 10; size < rowCount && size < maxSize; size += 10) {
        pageSizes.push({
          value: size,
          text: size,
        });
      }
      if (rowCount < maxSize) {
        pageSizes.push({
          value: rowCount,
          text: `Show all`,
        });
      }
    }

    return (
      <div className={'table-component ' + this.props.className}>
        {this.props.searchCallback && (
          <div className="table-search">
            <form onSubmit={this.onSearch}>
              <TextInput
                name="search"
                label="Search"
                onChange={this.onSearchInputChange}
                placeholder={this.props.searchPlaceholder}
              />
              <Button
                buttonClass="btn-primary"
                extraClass="search-button"
                buttonText="Search"
                onClick={this.onSearch}
              />
            </form>
          </div>
        )}

        {this.props.onSelectPageSize && this.props.pageSize && this.props.pagePosition !== 'bottom' && (
          <SelectInput
            name="Items per page"
            onChange={this.onSelectPageSize}
            label={'Items per page:'}
            extraClass="table-page-size"
            options={pageSizes}
            value={this.props.pageSize.toString()}
          />
        )}
        <div className="bulk-actions">
          {this.props.bulkActions &&
            this.props.bulkActions.map((action, index) => {
              let bulkAction = () => {
                let selectedRows = this.getSelectedRows();
                if ((selectedRows && selectedRows.length > 0) || action.bypassCheck) {
                  action.onClick(selectedRows);
                }
              };

              if (action.type) {
                if (action.type === 'select') {
                  return (
                    <SelectInput
                      key={index}
                      name={action.text}
                      onChange={action.onChange}
                      label={action.text}
                      labelKey={action.labelKey}
                      valueKey={action.valueKey}
                      options={action.options}
                      extraClass={' bulk-select ' + action.className}
                      value={action.value}
                    />
                  );
                } else if (action.type === 'input') {
                  return (
                    <TextInput
                      name={action.text}
                      label=""
                      key={index}
                      inlineLabel={action.text}
                      extraClass={' bulk-select bulk-input ' + action.className}
                      value={action.value}
                      onChange={action.onChange}
                      placeholder={action.placeholder}
                    />
                  );
                }
              } else {
                return (
                  <Button
                    key={index}
                    extraClass={'bulk-action bulk-action-btn ' + action.className}
                    hasPermission={action.hasPermission}
                    buttonText={action.text}
                    onClick={bulkAction}
                    disabled={
                      action.hasPermission !== undefined && !action.hasPermission ? false : action.disabled || false
                    }
                  />
                );
              }
            })}
        </div>
        <div className="table-container-div">
          <table className={'table ' + this.props.className}>
            <thead>
              <tr>
                {columnHeaders.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, index) => {
                return (
                  <TableRow
                    key={index}
                    index={index}
                    columns={this.props.columns}
                    editableColumns={this.props.editableColumns}
                    row={row}
                    selectable={this.props.bulkActions instanceof Array && this.props.bulkActions.length > 0}
                    selected={this.state.selection[index]}
                    onSelect={this.toggleSelectRow}
                    onRowSave={this.props.onRowSave}
                    editText={this.props.editText}
                    columnHeaders={columnHeaders}
                    cantEdit={this.props.cantEdit}
                  />
                );
              })}
              {this.props.rows.length === 0 && this.props.dataReturned && (
                <tr>
                  <td className="table-no-results" colSpan={columnHeaders.length}>
                    <b> No data </b>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {this.props.rows.length < 1 && this.props.errorMessage && (
          <AlertMessage type="warning" text={this.props.errorMessage} tag="No data" />
        )}
        {this.props.pageCount > 1 && ( // Display pagination if more than one page
          <Pagination pageCount={this.props.pageCount} currentPage={this.props.page} onSelectPage={this.onSelectPage} />
        )}
        {!this.props.dataReturned && !this.props.hideLoading && (
          <div className="center">
            <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
            <span className="sr-only">Loading...</span>
          </div>
        )}

        {this.props.onSelectPageSize && this.props.pageSize && this.props.pagePosition === 'bottom' && (
          <SelectInput
            name="Items per page"
            onChange={this.onSelectPageSize}
            label={'Items per page:'}
            extraClass="table-page-size"
            options={pageSizes}
            value={this.props.pageSize.toString()}
          />
        )}

        {this.props.bottomButtons &&
          this.props.bottomButtons.map((action, index) => {
            let bulkAction = () => {
              let selectedRows = this.getSelectedRows();
              if ((selectedRows && selectedRows.length > 0) || action.bypassCheck) {
                action.onClick(selectedRows);
              }
            };
            return (
              <Button
                key={index}
                extraClass={'bulk-action bulk-action-btn pull-right'}
                buttonText={action.text}
                onClick={bulkAction}
                disabled={action.disabled || false}
              />
            );
          })}
      </div>
    );
  }
}

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  editableColumns: PropTypes.object,
  bulkActions: PropTypes.arrayOf(PropTypes.object),
  searchCallback: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onRowSave: PropTypes.func,
  onSelectPageSize: PropTypes.func,
  onSelectPage: PropTypes.func,
  page: PropTypes.number,
  pageCount: PropTypes.number,
  pageSize: PropTypes.number,
  rowCount: PropTypes.number,
  errorMessage: PropTypes.string,
  dataReturned: PropTypes.bool,
  hideLoading: PropTypes.bool,
  editText: PropTypes.string,
  className: PropTypes.string,
  pagePosition: PropTypes.string,
  bottomButtons: PropTypes.arrayOf(PropTypes.object),
  cantEdit: PropTypes.array,
};

export default Table;
